import React from 'react';

export type LinkContextValue = {
  link: React.ComponentType<{ href: string; passHref?: boolean }>;
};

const LinkContext = React.createContext<LinkContextValue | null>(null);

export default LinkContext;
